import axios from 'axios'
import serializeError from 'serialize-error'
import { curry, compose } from 'ramda'
import history from '../history'
import logger from './logger/index'
import localStorage from './localStorage';
import handleRequestResponseError from './handleRequestResponseError'

//eslint-disable-next-line no-undef
const baseApiUrl = process.env.BASE_API_URL || __baseApiUrl__

export function setToken(token) {
  localStorage.setItem('token', token)
}

const generateHistoryObj = (search, error) => {
  const historyObj = {
    pathname: "/error",
    state: {
      error: serializeError(error)
    }
  }

  if (search) {
    historyObj.search = search
  }

  return historyObj
}

const handleErrorContainingResponse = (error) => {
  if (error.response) {
    const errorStatus = error.response.status;
    const invalidTokenStatusCode = 401;

    if (errorStatus === invalidTokenStatusCode) {
      localStorage.clear();
    }
  }
};

export const handleSearchError = curry((search, error) => {
  if (error) {
    handleErrorContainingResponse(error);
    logger.error(error);
    history.push(generateHistoryObj(search, error));
  }
});

export const handleError = handleSearchError(null);

export default () => new axiosWrapper();
class axiosWrapper{
  constructor(){
    this.axiosInstance = axios.create({
      baseURL: baseApiUrl + '/api/v1/',
      // timeout: 10000,
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` }
    });
  }
  get(path){
    return new Promise((resolve, reject) => {
      this.axiosInstance.get(path).
        then(resolve).
        catch(compose(reject, handleRequestResponseError));
    });
  }
  post(path, data){
    return new Promise((resolve, reject) => {
      this.axiosInstance.post(path, data).
        then(resolve).
        catch(compose(reject, handleRequestResponseError));
    });
  }
  put(path, data){
    return new Promise((resolve, reject) => {
      this.axiosInstance.put(path, data).
        then(resolve).
        catch(compose(reject, handleRequestResponseError));
    });
  }
  patch(path, data){
    return new Promise((resolve, reject) => {
      this.axiosInstance.patch(path, data).
        then(resolve).
        catch(compose(reject, handleRequestResponseError));
    });
  }
  delete(path){
    return new Promise((resolve, reject) => {
      this.axiosInstance.delete(path).
        then(resolve).
        catch(compose(reject, handleRequestResponseError));
    });
  }
}



// WEBPACK FOOTER //
// ./src/common/api.js